import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { downtimeGuard } from './core/guards/downtime.guard';
import { groupPermissionGuard } from './core/guards/group-permission.guard';

const authGuards = [MsalGuard, groupPermissionGuard];

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/projects'
  },
  {
    path: 'projects',
    loadComponent: () => import('./features/projects/projects.component').then(c => c.ProjectsComponent),
    canActivate: authGuards,
  },
  {
    path: 'reports',
    loadComponent: () => import('./features/reports/reports.component').then(c => c.ReportsComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/project',
    loadComponent: () => import('./features/administration/project/project.component').then(c => c.ProjectComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/organization',
    loadComponent: () => import('./features/administration/organization/organization.component').then(c => c.OrganizationComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/tenant',
    loadComponent: () => import('./features/administration/tenant/tenant.component').then(c => c.TenantComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/application',
    loadComponent: () => import('./features/administration/application/application.component').then(c => c.ApplicationComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/feature',
    loadComponent: () => import('./features/administration/feature/feature.component').then(c => c.FeatureComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/test-case',
    loadComponent: () => import('./features/administration/test-case/test-case.component').then(c => c.TestCaseComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/users',
    loadComponent: () => import('./features/administration/users/users.component').then(c => c.UsersComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/online-help',
    loadComponent: () => import('./online-help/online-help.component').then(c => c.OnlineHelpComponent),
    canActivate: authGuards,
  },
  {
    path: 'administration/downtime',
    loadComponent: () => import('./downtime/downtime.component').then(c => c.DowntimeComponent),
    canActivate: authGuards,
  },
  {
    path: 'unavailable',
    loadComponent: () => import('./unavailable/unavailable.component').then(c => c.UnavailableComponent),
    canActivate: [MsalGuard, downtimeGuard]
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./401/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./404/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  }
];
